import * as React from 'react';
export const GradientStarIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={27}
    viewBox="0 0 28 27"
    fill="none"
    {...props}
  >
    <path
      fill="#FFA600"
      d="m27.286 12.356-5.625 4.854 1.714 7.258a2.05 2.05 0 0 1-3.063 2.228L14 22.811l-6.316 3.885a2.049 2.049 0 0 1-3.06-2.228l1.72-7.258L.72 12.356A2.057 2.057 0 0 1 1.885 8.75l7.375-.595 2.845-6.885a2.045 2.045 0 0 1 3.784 0l2.843 6.885 7.375.595a2.058 2.058 0 0 1 1.172 3.607l.007-.001Z"
    />
    <path
      fill="url(#a)"
      fillOpacity={0.5}
      d="m27.286 12.356-5.625 4.854 1.714 7.258a2.05 2.05 0 0 1-3.063 2.228L14 22.811l-6.316 3.885a2.049 2.049 0 0 1-3.06-2.228l1.72-7.258L.72 12.356A2.057 2.057 0 0 1 1.885 8.75l7.375-.595 2.845-6.885a2.045 2.045 0 0 1 3.784 0l2.843 6.885 7.375.595a2.058 2.058 0 0 1 1.172 3.607l.007-.001Z"
      style={{
        mixBlendMode: 'overlay',
      }}
    />
    <defs>
      <linearGradient id="a" x1={14} x2={14} y1={0.001} y2={26.997} gradientUnits="userSpaceOnUse">
        <stop stopOpacity={0} />
        <stop offset={1} />
      </linearGradient>
    </defs>
  </svg>
);
